module.exports = __webpack_public_path__ + "img/15.f0eb8387.jpg";